import { render, staticRenderFns } from "./accounts-overview.component.vue?vue&type=template&id=31ea2da8&"
import script from "./accounts-overview.component.vue?vue&type=script&lang=ts&"
export * from "./accounts-overview.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports